import React from 'react';

import AddIcon from '@mui/icons-material/Add';

import {
    useIncludedNotPlanned,
    useOnlyNotAssigned,
    useOnlyNotPlanned,
    useSourceSetDates,
} from '../../../../selectors/index.hooks';

import IconButtonWithTooltip from '../../../../../../components/IconButtonWithTooltip';

import { clearForm } from '../../../../../../state/ui/forms';
import {
    fetchTasks,
    resetLastMapClickPosition,
} from '../../../../../../state/_actions';
import { usePrivileges } from '../../../../../../state/auth/index.hooks';

import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import { useAppDispatch } from '../../../../../../hooks';
import { useGridSourceSet } from '../../../../selectors/composed/index.hooks';
import { showTaskModificationDialog } from '../../../../../../state/ui/dialog';
import { useAddLocation } from '../../../../components/PreviewPane/components/TaskPane/hooks/useAddLocation';
import { FormikValues } from 'formik';

interface IOwnProps {
    isGridFullscreen: boolean;
}

const TasksAddButton = ({ isGridFullscreen }: IOwnProps) => {
    const dispatch = useAppDispatch();

    const sourceSet = useGridSourceSet();

    const privileges = usePrivileges();
    const dates = useSourceSetDates();
    const sourceSetDates = useSourceSetDates();
    const onlyNotPlanned = useOnlyNotPlanned();
    const onlyNotAssigned = useOnlyNotAssigned();
    const includeNotPlanned = useIncludedNotPlanned();
    const activateAddLocationPane = useAddLocation();

    const handleAddLocation = (values: FormikValues) => {
        activateAddLocationPane(values);
    };

    const handleFetchTasks = () => {
        if (!sourceSetDates) {
            return;
        }
        const fetchTasksParams = () => {
            return onlyNotPlanned
                ? {
                      onlyNotAssigned,
                      includeNotPlanned: true,
                  }
                : {
                      from: sourceSetDates.from,
                      to: sourceSetDates.to,
                      onlyNotAssigned,
                      includeNotPlanned,
                  };
        };
        dispatch(fetchTasks(fetchTasksParams()));
    };

    const openCreatePane = () => {
        if (sourceSet) {
            dispatch(resetLastMapClickPosition());

            dispatch(clearForm({ type: 'task' }));
            dispatch(
                showTaskModificationDialog({
                    dates,
                    onSuccess: handleFetchTasks,
                    handleAddLocation,
                    mode: 'add',
                })
            );
        }
    };

    const addAction = sourceSet?._meta?.actions?.add;
    if (!isGridFullscreen && privileges.addTask && addAction) {
        return (
            <IconButtonWithTooltip
                title={TranslationHelper.translate('Add')}
                onClick={openCreatePane}
            >
                <AddIcon />
            </IconButtonWithTooltip>
        );
    }
    return null;
};

export default TasksAddButton;
